// extracted by mini-css-extract-plugin
export var customClustericon = "map-module--customClustericon--aabae";
export var marker = "map-module--marker--92438";
export var wrapper = "map-module--wrapper--9a47e";